import { useState, useEffect } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Loader from "components/Loader";
import useCurrentUser from "hooks/useCurrentUser";
import { Col, Row } from "react-bootstrap";
import { userService, utilService } from "services";
import EditProfileForm from "components/Dashboard/EditProfileForm";
import EditMachineForm from "components/Dashboard/EditMachineForm";
import CommonModal from "components/Modals/CommonModal";
import DeleteAccount from "components/Modals/Alertpopus/DeleteAccount";

// Sub-components
import PersonalDetails from "components/Dashboard/MyAccount/PersonalDetails";
import PrimaryMachineInfo from "components/Dashboard/MyAccount/PrimaryMachineInfo";
import DocumentSection from "components/Dashboard/MyAccount/DocumentSection";
import PortfolioMedia from "components/Dashboard/MyAccount/PortfolioMedia";
import MachineSection from "components/Dashboard/MyAccount/MachineSection";

const MyAccount = ({ deleteAccount }) => {
  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { user, loading, setUser } = useCurrentUser();
  const [formType, setFormType] = useState(null);
  const [docType, setDocType] = useState({});
  const [currentFile, setCurrentFile] = useState(null);
  const [faaNumber, setFaaNumber] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(loading);
  const [isDelete, setIsDelete] = useState(false);
  const [fileNames, setFileNames] = useState({});
  const [selectedMachines, setSelectedMachines] = useState([]);

  useEffect(() => {
    if (!loading) {
      setFaaNumber(user?.faaRegistrationNumber);
      const userDrones = user?.portfolio?.drones || [];
      if (userDrones.length > 0) {
        setSelectedMachines(userDrones);
      }
    }
  }, [loading, user]);

  const handleClose = () => setShow(false);

  const handleShow = (type) => {
    setShow(true);
    setFormType(type);
  };

  const onCloseModal = () => {
    setShowModal(false);
    setError(null);
    setCurrentFile(null);
  };

  const onOpenModal = (data) => {
    setShowModal(true);
    setDocType(data);
  };

  const handleFileUpload = async (e) => {
    setError(null);
    const file = e.target.files[0];
    const extension = file.name.split(".").pop();

    try {
      setIsLoading(true);
      const response = await utilService.getBucketUrl({
        location: "users/",
        extension,
      });
      const webUrlData = response.data.data[0];
      const { filename, url } = webUrlData || {};

      const requestOptions = {
        method: "PUT",
        headers: {
          "Content-Type": file.type,
        },
        body: file,
        redirect: "follow",
      };

      await utilService.uploadFile({
        url,
        requestOptions,
      });
      if (e.target.name === "avatar") {
        const profile = await userService.updateProfilePicture({
          avatar: filename,
        });
        setUser(profile?.data?.data);
        localStorage.setItem("userData", JSON.stringify(profile?.data?.data));
      } else {
        setCurrentFile(filename);
      }
      setFileNames({
        ...fileNames,
        [e.target.name]: file.name,
      });
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      setIsLoading(true);
      if (docType?.type === "FAA" && !faaNumber) {
        setError("Please enter number!");
        return;
      }
      if (!currentFile) {
        setError("Please upload File!");
        return;
      }
      setError(null);
      const payload = {
        updateType: docType?.type,
        [docType?.key]: currentFile,
      };

      if (faaNumber) {
        payload.faaRegistrationNumber = faaNumber;
      }
      const resultData = await userService.updatePilotProfile(payload);
      setUser(resultData?.data?.data);
      setShowModal(false);
      setCurrentFile(null);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container-box">
      <div className="top-head d-flex flex-wrap justify-content-between align-items-center text-white">
        <h2>Profile</h2>
      </div>
      <div className="outer-white">
        <Row>
          <Loader loading={isLoading} />
          <Col xl={4} lg={12}>
            <PersonalDetails
              user={user}
              handleShow={handleShow}
              handleFileUpload={handleFileUpload}
              setIsDelete={setIsDelete}
            />
          </Col>

          <Col xl={8} lg={12}>
            <PrimaryMachineInfo user={user} handleShow={handleShow} />
            <DocumentSection user={user} onOpenModal={onOpenModal} />
          </Col>
        </Row>

        <PortfolioMedia
          user={user}
          setUser={setUser}
          selectedMachines={selectedMachines}
        />

        <MachineSection
          user={user}
          selectedMachines={selectedMachines}
          setSelectedMachines={setSelectedMachines}
        />
      </div>

      <Offcanvas
        show={show}
        onHide={handleClose}
        backdrop="static"
        placement="end"
      >
        <Offcanvas.Header closeButton></Offcanvas.Header>
        <Offcanvas.Body className="p-20">
          {formType === "machine" ? (
            <EditMachineForm
              user={user}
              setUser={setUser}
              handleClose={handleClose}
            />
          ) : (
            <EditProfileForm
              user={user}
              setUser={setUser}
              handleClose={handleClose}
            />
          )}
        </Offcanvas.Body>
      </Offcanvas>

      <CommonModal
        show={showModal}
        handleClose={onCloseModal}
        docData={docType}
        handleChange={handleFileUpload}
        handleSave={handleSave}
        currentFile={currentFile}
        setFaaNumber={setFaaNumber}
        error={error}
        setError={setError}
        faaNumber={faaNumber}
        isLoading={isLoading}
        fileNames={fileNames}
      />

      <DeleteAccount
        show={isDelete}
        handleClose={() => {
          setIsDelete(false);
        }}
        deleteAccount={deleteAccount}
      />
    </div>
  );
};

export default MyAccount;
